export const DailyCardsLoading = () => {
  return (
    <div className="grid w-full grid-cols-3 gap-sh-15">
      <div className={`flex animate-pulse flex-col items-center gap-sh-15 rounded-2xl  bg-gray-100 p-5 text-center`}>
        <div className="h-48 w-full" />
      </div>
      <div className={`flex animate-pulse flex-col items-center gap-sh-15 rounded-2xl  bg-gray-100 p-5 text-center`}>
        <div className="h-48 w-full" />
      </div>
      <div className={`flex animate-pulse flex-col items-center gap-sh-15 rounded-2xl  bg-gray-100 p-5 text-center`}>
        <div className="h-48 w-full" />
      </div>
    </div>
  );
};
